export const ACCESSIBILITY_ISOPEN = 'ACCESSIBILITY_ISOPEN';
export const ACCESSIBILITY_DEFAULT_THEME = 'ACCESSIBILITY_DEFAULT_THEME';
export const ACCESSIBILITY_BASE_FONT_SIZE = 'ACCESSIBILITY_BASE_FONT_SIZE';
export const ACCESSIBILITY_RESET = 'ACCESSIBILITY_RESET';

export const accessibilityIsOpenToggle = () => ({ type: ACCESSIBILITY_ISOPEN });
export const accessibilityDefaultTheme = status => ({ type: ACCESSIBILITY_DEFAULT_THEME, status });
export const accessibilityBaseFontSize = payload => ({
  type: ACCESSIBILITY_BASE_FONT_SIZE,
  payload
});
export const accessibilityReset = () => ({ type: ACCESSIBILITY_RESET });
